import styled from 'styled-components';
import { RouterLink } from '@redux-first-router-link';
import { buttonCSS, Grid } from '@simplywallst/ui-core';
import type { ButtonProps } from '@simplywallst/ui-core';

export const Wrapper = styled(Grid)`
  height: 100%;
  padding: ${({ theme }) => `20px ${theme.x2spacePx}px ${theme.x2spacePx}px`};
  > h3 {
    margin-top: ${({ theme }) => theme.x2spacePx}px;
    margin-bottom: ${({ theme }) => theme.x3spacePx}px;
  }
`;

export const Button = styled(RouterLink)<ButtonProps>`
  ${buttonCSS}
  text-align: center;
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
`;
